import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";

const StackedBarChart = ({ data }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (!data || Object.keys(data).length === 0) {
      console.warn("No valid data provided for the chart.");
      return;
    }

    const result = Object.values(data).map((key) => [key]);
    const vardd = result.flat();

    const ctx = chartRef.current.getContext("2d");

    const myChart = new Chart(ctx, {
      type: "bar",
      data: {
        labels: [
          " Material Inspection",
          "Welding Gas Certification",
          "Machine Certification",
          "Welder Certification",
          "Isometric Weld Log",
        ],
        datasets: [
          {
            label: "Inspection count",
            backgroundColor: [
              "#6366F1",
              "#06B6D4",
              "#10B981",
              "#F59E0B",
              "#F43F5E",
            ],
            borderRadius: 8,
            data: vardd,
          },
        ],
      },
      options: {
        tooltips: {
          displayColors: true,
          callbacks: {
            mode: "x",
          },
        },
        scales: {
          x: {
            stacked: true,
            grid: {
              display: false,
            },
            ticks: {
              color: "#64748B",
              font: {
                size: 12,
                weight: 500,
              },
            },
          },
          y: {
            stacked: true,
            ticks: {
              beginAtZero: true,
              color: "#64748B",
            },
            grid: {
              color: "#E2E8F0",
            },
            type: "linear",
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "bottom",
            labels: {
              color: "#334155",
            },
          },
        },
      },
    });

    return () => {
      myChart.destroy();
    };
  }, [data]);

  if (!data || Object.keys(data).length === 0) {
    return (
      <div className="flex justify-center items-center">
        <div className="bg-white border border-slate-200 shadow-sm p-6 rounded-xl w-full">
          <p className="text-center text-slate-500 text-sm font-medium">
            No data available to display.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-center items-center">
      <div className="bg-white border border-slate-200 shadow-sm p-6 rounded-xl w-full">
        <canvas
          ref={chartRef}
          className="bg-white top-0 left-0 w-full h-[350px]"
        ></canvas>
      </div>
    </div>
  );
};

export default StackedBarChart;
